((tippy) => {
  const tooltipDuration = 1500;
  const permalink = window.location.href;
  const copyLinkButton = document.getElementById('resource-share-copy-link');

  if (!copyLinkButton) return;

  tippy(copyLinkButton, {
    trigger: 'click',
    placement: 'top',
    onShow(instance) {
      setTimeout(() => {
        instance.hide();
      }, tooltipDuration);
    },
  });

  copyLinkButton.addEventListener('click', () => {
    navigator.clipboard.writeText(permalink);
  });
})(window.tippy, window.args);
